import React from 'react';
import { useIntl, defineMessages } from 'react-intl-next';

import Select from '@atlaskit/select';

const i18n = defineMessages({
	placeholder: {
		id: 'bulk-permissions.space-exclusion.multi-space-selector.placeholder.non-final',
		defaultMessage: 'Search space name or key',
		description: 'placeholder for the space selector',
	},
});

export const MultiSpaceSelector = () => {
	const { formatMessage } = useIntl();
	return (
		<>
			<Select testId="multi-space-selector" placeholder={formatMessage(i18n.placeholder)} />
		</>
	);
};
